import script from "./CardBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBlock.vue?vue&type=script&setup=true&lang=js"

import "./CardBlock.vue?vue&type=style&index=0&id=71634852&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71634852"]])

export default __exports__